export enum AppErrorCode {
  LOADING_ERROR = '456',
  FIND_GAP_RECURSION = '734',
  UNKNOWN = '000'
}
